import { useEffect, useState, useCallback } from "react";
import { api, apiError } from "@/lib/api";

/** Paged activity fetch shared by the List and Timeline views. */
export function useActivities(apiParams, type, pageSize = 25, refreshKey = 0) {
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ items: [], total: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => { setPage(1); }, [apiParams, type]);

  const load = useCallback(async () => {
    setLoading(true); setError("");
    try {
      const { data } = await api.get("/activities", { params: { ...apiParams, ...(type ? { type } : {}), page, page_size: pageSize } });
      setData(data);
    } catch (e) { setError(apiError(e)); } finally { setLoading(false); }
  }, [apiParams, type, page, pageSize]);
  useEffect(() => { load(); }, [load, refreshKey]);

  return { ...data, page, setPage, loading, error, reload: load, pageSize };
}
